export interface GetInfoData {
  version: string;
  numDlcOffers: number;
  numDlcAccepts: number;
  numDlcSigns: number;
  blockHeight: number;
  blockHash: string;
  chain: string;
  nick: string;
  nodeId: string;
  ircSynced: boolean;
  chainSynced: boolean;
}

export const getGetInfoData = async (baseUrl: string): Promise<GetInfoData> => {
  const proxyUrl = "https://cors.atomic.finance/";
  const getInfoUrl = proxyUrl + `${baseUrl}/api/v0/getinfo`;
  const response = await fetch(getInfoUrl);
  const getInfoData: GetInfoData = await response.json();

  return getInfoData;
};
